import styled from 'styled-components';

const flexCenterStyles = (alignItems, justifyContent) => `
  display: flex;
  align-items: ${alignItems && 'center'};
  justify-content: ${justifyContent && 'center'};
`;

export const FlexCenterVertical = styled.div`
  display: flex;
  align-items: center;
`;

export const FlexCenterHorizontal = styled.div`
  ${flexCenterStyles(true)}
`;

export const FlexCenter = styled.div`
  ${flexCenterStyles(true, true)}
`;

export const FlexCenterColumn = styled.div`
  ${flexCenterStyles(true)}
  flex-direction: column;
`;
